import { render, staticRenderFns } from "./ContestEntryDataDialog.vue?vue&type=template&id=63a3e6ea&scoped=true"
import script from "./ContestEntryDataDialog.vue?vue&type=script&lang=ts"
export * from "./ContestEntryDataDialog.vue?vue&type=script&lang=ts"
import style0 from "./ContestEntryDataDialog.vue?vue&type=style&index=0&id=63a3e6ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3e6ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a3e6ea')) {
      api.createRecord('63a3e6ea', component.options)
    } else {
      api.reload('63a3e6ea', component.options)
    }
    module.hot.accept("./ContestEntryDataDialog.vue?vue&type=template&id=63a3e6ea&scoped=true", function () {
      api.rerender('63a3e6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ContestEntryDataDialog.vue"
export default component.exports